import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";

export const apiErrorHandler = (error: unknown) => {
    if (isFetchBaseQueryError(error)) {
        if (error.data && typeof error.data === "object") {
            const errorData = error.data as Record<string, string | string[]>;
            const messages = Object.values(errorData).flat();
            return {message: messages.join(", "), status: error.status as number};
        }
    }
    return null;
};
